<template>
  <layout
    titlePage="Cadastrar convites"
    :route="{ name: 'rsvp-configuracoes' }"
  >
    <SubmenuBack v-if="hasToShowNewMenu" />
    <section class="c-rsvp-invite">
      <div class="columns columns--full is-vcentered">
        <div class="column">
          <div class="container c-rsvp-invite__form">
            <div>
              <tag-icon class="mb-4" />
              <p class="c-rsvp-invite__title has-text-primary">
                <b v-if="isEditing">Editar convite</b>
                <b v-else>Cadastrar convite</b>
              </p>
            </div>
            <div
              class="columns is-multiline mb-0 gap-32 is-flex is-flex-direction-column"
            >
              <div class="column is-full pb-0">
                <div class="field">
                  <div
                    :class="{
                      'has-error':
                        validation.hasError('name') || errorsBackend.name,
                    }"
                    class="control"
                    autocomplete="off"
                  >
                    <label
                      for="invite-name"
                      class="label has-text-weight-bold is-flex is-align-items-center"
                    >
                      <span>
                        *Nome do convite:
                        <span class="has-text-weight-normal"
                          >(Ex.: Tia Ana e Família)</span
                        >
                      </span>
                      <span
                        data-tooltip="Crie convites para agrupar os convidados que irão juntos ao seu evento, por exemplo, Marisa e Família. Em seguida  cadastre individualmente cada convidado."
                        class="tooltip is-tooltip-left is-tooltip-top-tablet is-tooltip-multiline ml-4 is-inline-flex"
                      >
                        <base-icon
                          class="icon"
                          width="24px"
                          height="24px"
                          name="painel/filled-info-icon"
                        />
                      </span>
                    </label>
                    <input
                      id="invite-name"
                      v-model="name"
                      ref="FocusOnError"
                      class="input has-value outlined-field"
                      name="title"
                      type="text"
                      maxlength="50"
                    />
                    <p
                      v-if="validation.hasError('name') || errorsBackend.name"
                      class="help is-error"
                    >
                      {{
                        validation.firstError('name') ||
                        'Por favor, insira um nome de convite válido.'
                      }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="column py-0">
                <div class="control" autocomplete="off">
                  <div class="label-phone">
                    <p>*Telefone de contato do responsável pelo convite:</p>
                    <span>
                      Para confirmar a identidade, a pessoa que irá confirmar a
                      presença deverá inserir os 4 últimos dígitos do telefone a
                      seguir:
                    </span>
                  </div>
                  <VuePhoneNumberInput
                    v-model="phone"
                    :required="true"
                    :clearable="true"
                    :translations="{
                      countrySelectorLabel: 'Cod. País',
                      countrySelectorError: 'Escolha um país',
                      phoneNumberLabel: '',
                      example: 'Exemplo :',
                    }"
                    :preferredCountries="['BR']"
                    :error="validation.hasError('phone') || errorsBackend.phone"
                    :borderRadius="8"
                    :defaultCountryCode="defaultCountryCode"
                    color="#5D758D"
                    errorColor="#F65C6A"
                    validColor="#3DAFB0"
                    size="lg"
                    class="phone-number-input"
                    @update="updatedPhoneNumber"
                  />
                  <p
                    v-if="validation.hasError('phone') || errorsBackend.phone"
                    class="help is-error"
                  >
                    {{
                      validation.firstError('phone') ||
                      'Por favor, insira um número de telefone válido.'
                    }}
                  </p>
                </div>
              </div>
            </div>
            <div class="register-guests">
              <div v-if="isEditing" class="register-guests__title">
                <p>Editar convidados</p>
                <span>
                  Você pode editar todos os convidados vinculados a este
                  convite.
                </span>
              </div>
              <div v-else class="register-guests__title">
                <p>Cadastrar convidados</p>
                <span>
                  Cadastre todos os convidados vinculados a este convite.<b>
                    Caso não saiba ou prefira que o próprio convidado preencha
                    os dados, deixe os campos abaixo sem preenchimento.</b
                  >
                </span>
              </div>
              <div class="columns is-multiline">
                <div class="column is-full">
                  <div class="field">
                    <div class="control outlined-body" autocomplete="off">
                      <div class="outlined-content">
                        <div class="is-flex is-align-items-center label-group">
                          <tag-icon class="mr-4" />
                          <p
                            for="maxAdulto"
                            class="has-text-weight-bold has-text-left"
                          >
                            Quantidade de convidados neste convite
                          </p>
                        </div>
                        <div
                          class="input input-select"
                          :class="{ 'alert-select': cantDelete }"
                        >
                          <b-select
                            name="maxAdulto"
                            v-model="numberGuestSelect"
                            @input="addMissingGuests"
                          >
                            <option
                              class="select-items"
                              v-for="number in maxGuests"
                              :key="number"
                              :value="number"
                            >
                              {{ number }}
                            </option>
                          </b-select>
                        </div>
                      </div>
                      <div v-if="cantDelete" class="alert-delete-guests">
                        <base-icon
                          width="24px"
                          height="24px"
                          name="painel/info-modern-icon"
                        />
                        <p>
                          <b> Ação necessária: </b>
                          Você já possui
                          {{ numbersTranscription[guests.length] }} convidados
                          cadastrados. Para reduzir a quantidade neste convite,
                          é necessário excluir
                          {{
                            numbersTranscription[
                              guests.length - numberGuestSelect
                            ]
                          }}
                          convidados.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <GuestForm
                v-for="(guest, index) in guests"
                :key="Math.random() + index"
                :orderIndex="index"
                :totalGuests="guests.length"
                :guest="guest"
                @change="updateGuest"
                @delete="
                  (index) =>
                    isEditing && guest.id
                      ? $refs.modalConfirmDeleteGuest.open(index)
                      : deleteGuestFromView(index)
                "
              />

              <p v-if="errorsBackend.guests" class="has-text-danger">
                Por favor, confira se as informações dos convidados estão
                corretas.
              </p>

              <button
                v-if="this.guests.length < 10"
                class="add-guest"
                type="button"
                @click="addGuest"
              >
                <base-icon
                  class="icon"
                  width="24px"
                  height="24px"
                  name="painel/plus-circle"
                />
                Adicionar novo convidado
              </button>

              <div class="c-rsvp-invite__actions">
                <button
                  v-if="!isEditing"
                  :disabled="cantSave"
                  class="button"
                  type="button"
                  @click="() => createInvite(true)"
                >
                  Salvar e cadastrar outro convite
                </button>
                <button
                  v-if="isEditing"
                  :disabled="!canEdit || loading"
                  class="button is-primary"
                  type="button"
                  @click="editInvite"
                >
                  Salvar alterações
                </button>
                <button
                  v-else
                  :disabled="cantSave"
                  class="button is-primary"
                  type="button"
                  @click="() => createInvite(false)"
                >
                  Finalizar cadastro
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <ModalActionConfirmation
      ref="modalConfirmDeleteGuest"
      title="Confirmação de exclusão"
      message="Atenção! Este convidado será excluído permanentemente. Tem certeza de que deseja excluir?"
      @confirmed="deleteGuestFromDatabase($event)"
    />
  </layout>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import VuePhoneNumberInput from 'vue-phone-number-input'
import SimpleVueValidator from 'simple-vue-validator'
import layout from '@/layouts/Default.vue'
import TagIcon from '@/components/Rsvp/TagIcon.vue'
import GuestForm from '@/components/Rsvp/GuestForm.vue'
import SubmenuBack from '@/layouts/parts/SubmenuBack.vue'
import ModalActionConfirmation from '@/components/Shared/ModalActionConfirmation.vue'

import RsvpApi from '@/lib/api/Rsvp'

const Validator = SimpleVueValidator.Validator

const GUEST = {
  name: '',
  type: undefined,
  confirmed: 'maybe',
}

export default {
  mixins: [SimpleVueValidator.mixin],

  components: {
    layout,
    TagIcon,
    SubmenuBack,
    VuePhoneNumberInput,
    GuestForm,
    ModalActionConfirmation,
  },

  metaInfo: {
    title: 'RSVP - Cadastrar convites',
  },

  validators: {
    name(value) {
      return Validator.value(value)
        .required('Por favor, insira um nome.')
        .lengthBetween(
          2,
          50,
          'Por favor, insira um nome entre 2 e 50 caracteres.'
        )
        .regex(
          /^[A-Za-zÁÉÍÓÚÀÈÌÒÙÂÊÎÔÛÃÕÑÇáéíóúàèìòùâêîôûãõñç ]+$/,
          'Por favor, insira apenas caracteres alfabéticos (A-Z ou a-z) sem números ou símbolos.'
        )
    },
    phone() {
      return Validator.value(this.phone)
        .required('Por favor, insira um número de telefone válido.')
        .lengthBetween(8, 20, 'Por favor, insira um número de telefone válido.')
    },

    numberGuestSelect(value) {
      return Validator.value(value).required().integer().between(1, 10)
    },
  },

  computed: {
    ...mapGetters({
      rsvps: 'getRsvps',
      rsvpConfigs: 'getRsvpConfigs',
      logonToken: 'app/logonToken',
      wedId: 'app/getWedId',
    }),

    defaultCountryCode() {
      return this.country_code ?? 'BR'
    },

    isEditing() {
      return !!this.$route.params.inviteId
    },

    hasToShowNewMenu() {
      return this.$store.state.app.wedSiteInfo.site_menu_versao ? true : false
    },

    cantDelete() {
      return this.numberGuestSelect < this.guests.length
    },

    hasChanges() {
      return (
        this.rsvpInitial?.name !== this.name ||
        this.rsvpInitial?.phone !== this.phone ||
        this.rsvpInitial?.max_guests !== this.numberGuestSelect ||
        JSON.stringify(this.rsvpInitial?.guests) !== JSON.stringify(this.guests)
      )
    },

    canEdit() {
      return (
        this.validation.isTouched('name') ||
        this.validation.isTouched('phone') ||
        this.validation.isTouched('numberGuestSelect') ||
        this.hasChanges ||
        this.guestsTouched
      )
    },

    cantSave() {
      if (
        !this.validation.isTouched('name') ||
        !this.validation.isTouched('phone')
      )
        return true

      return (
        this.validation.hasError('name') ||
        this.validation.hasError('phone') ||
        this.validation.hasError('numberGuestSelect') ||
        this.loading
      )
    },
  },

  data() {
    return {
      guests: [{ ...GUEST }],
      errorsBackend: {},
      rsvpInitial: {},
      maxGuests: 10,
      numberGuestSelect: 1,
      guestsTouched: false,
      phone: '',
      ddi: '',
      country_code: '',
      name: '',
      loading: false,
      numbersTranscription: {
        ['1']: 'um',
        ['2']: 'dois',
        ['3']: 'três',
        ['4']: 'quatro',
        ['5']: 'cinco',
        ['6']: 'seis',
        ['7']: 'sete',
        ['8']: 'oito',
        ['9']: 'nove',
        ['10']: 'dez',
      },
    }
  },

  mounted() {
    if (!this.rsvpConfigs?.mode) {
      this.fetchRsvpConfigs()
    }

    this.setRsvpToEdit()
  },

  methods: {
    ...mapActions({
      fetchRsvps: 'fetchRsvps',
      fetchRsvpConfigs: 'fetchRsvpConfigs',
      notification: 'app/setNotification',
    }),

    updatedPhoneNumber(event) {
      this.ddi = `+${event.countryCallingCode}`
      this.country_code = event.countryCode
    },

    async setRsvpToEdit() {
      const { inviteId } = this.$route.params
      if (!inviteId) return

      let rsvps = this.rsvps
      if (rsvps.length === 0) {
        rsvps = await this.fetchRsvps()
      }

      const rsvp = rsvps.find(({ id }) => Number(id) === Number(inviteId))
      if (rsvp) {
        this.setRsvpDetails(rsvp)
        this.addMissingGuests()
        this.rsvpInitial.guests = this.guests
        this.validation.reset()
      } else this.$router.push({ name: 'rsvp' })
    },

    setRsvpDetails(rsvp) {
      this.rsvpInitial = { ...rsvp }
      this.name = rsvp.name
      this.phone = rsvp.phone
      this.ddi = rsvp.ddi
      this.country_code = rsvp.country_code
      this.guests = rsvp.guests
      this.numberGuestSelect = rsvp.max_guests
    },

    addMissingGuests() {
      const missing = this.numberGuestSelect - this.guests.length
      if (missing <= 0) return

      this.guests = [
        ...this.guests,
        ...Array.from({ length: missing }, () => ({
          ...GUEST,
        })),
      ]
    },

    resetEdition() {
      this.setRsvpDetails({
        name: this.name,
        phone: this.phone,
        ddi: this.ddi,
        country_code: this.country_code,
        guests: this.guests,
        max_guests: this.numberGuestSelect,
      })
      this.addMissingGuests()
      this.guestsTouched = false
      this.validation.reset()
    },

    updateGuest(guest, index, elementToFocus) {
      this.guestsTouched = true
      this.guests[index] = {
        ...this.guests[index],
        ...guest,
      }

      this.$nextTick(() => {
        if (elementToFocus) {
          document.getElementById(elementToFocus).focus()
        }
      })
    },

    deleteGuestFromView(index) {
      if (index > -1 && index < this.guests.length) {
        this.guests.splice(index, 1)
        this.numberGuestSelect = this.guests.length
      }
    },
    addGuest() {
      this.numberGuestSelect++
      this.addMissingGuests()
    },

    async deleteGuestFromDatabase(index) {
      this.loading = true
      const guest = this.guests[index]

      if (guest.id) {
        const api = new RsvpApi(this.logonToken)

        api
          .deleteGuest(guest.id)
          .then(() => {
            this.deleteGuestFromView(index)
            this.editInvite()
          })
          .catch((error) => {
            this.notification({
              message: 'Erro ao excluir. Por favor, tente novamente.',
              show: true,
              timeout: 3000,
              class: 'is-error ',
            })
          })
          .finally(() => {
            this.loading = false
          })
      }
    },

    handleErrorsFromBackend(errors) {
      this.errorsBackend = {
        name: !!errors?.name || false,
        phone: !!errors?.phone || false,
        guests: !!errors?.guests || false,
      }
    },

    async createInvite(saveAndRestart = false) {
      this.loading = true
      this.errorsBackend = {}
      const guests = this.guests.filter((guest) => guest.name !== '')
      const hasGuests = guests.length > 0

      const data = {
        wed_id: this.wedId,
        name: this.name,
        phone: this.phone,
        ddi: this.ddi,
        country_code: this.country_code,
        max_guests: this.guests.length,
        guests: hasGuests ? guests : null,
      }

      const api = new RsvpApi(this.logonToken)

      api
        .createInvite(data)
        .then(() => {
          this.notification({
            message: 'Convite cadastrado com sucesso!',
            show: true,
          })

          setTimeout(() => {
            if (saveAndRestart) location.reload()
            else this.$router.push({ name: 'rsvp' })
          }, 1500)
        })
        .catch((error) => {
          this.handleErrorsFromBackend(error?.response?.data?.error?.errors)
          this.notification({
            message: 'Erro no salvamento. Por favor, tente novamente.',
            show: true,
            timeout: 5000,
            class: 'is-error ',
          })
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false
          }, 1500)
        })
    },

    async editInvite() {
      this.loading = true
      this.errorsBackend = {}

      const guests = this.guests.filter((guest) => !!guest.name)
      const hasGuests = guests.length > 0

      const data = {
        wed_id: this.wedId,
        name: this.name,
        phone: this.phone,
        ddi: this.ddi,
        country_code: this.country_code,
        max_guests: this.guests.length,
        guests: hasGuests ? guests : null,
      }

      const api = new RsvpApi(this.logonToken)

      api
        .editInvite(data, this.$route.params.inviteId)
        .then(() => {
          this.notification({
            message: 'Convite atualizado com sucesso!',
            show: true,
          })

          this.resetEdition()
        })
        .catch((error) => {
          this.handleErrorsFromBackend(error?.response?.data?.error?.errors)
          this.notification({
            message: 'Erro no salvamento. Por favor, tente novamente.',
            show: true,
            timeout: 5000,
            class: 'is-error ',
          })
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false
          }, 1500)
        })
    },
  },
}
</script>
<style lang="scss">
.c-rsvp-invite {
  padding-right: 20px;
  padding-left: 20px;
  color: #5d758d;
  &__form {
    margin-top: 8px;
    display: flex;
    flex-direction: column;
    gap: 56px;
    @media (min-width: $desktop) {
      margin-top: 80px;
      padding: 0 80px;
    }
  }

  &__title {
    font-size: 24px;
    line-height: 1;
    @media (max-width: $tablet) {
      font-size: 20px;
    }
  }
  &__actions {
    text-align: center;
    margin-top: 30px;
    @media (min-width: $tablet) {
      text-align: right;
      margin-top: 40px;
    }

    button,
    a {
      width: 100%;
      margin: 0;
      margin-bottom: 20px;

      @media (min-width: $tablet) {
        width: auto;
        margin-left: 15px;
      }
    }
  }
  .add-guest {
    color: $support;
    font-size: 16px;
    display: flex;
    align-items: center;
    gap: 8px;
    width: fit-content;
    cursor: pointer;
    background: transparent;
    border: none;
    font-weight: 700;
  }
  .label {
    position: static;
    pointer-events: auto;
    font-size: 16px !important;
    color: $neutral;
    line-height: 1.14;
    font-weight: bold;
    &.disabled {
      color: $neutrallight !important;
    }
  }
  .label-phone {
    display: flex;
    margin-bottom: 16px;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    font-size: 16px;
    align-self: stretch;
    p {
      color: $neutral;
      font-weight: 700;
    }
    span {
      color: $gray-5;
      line-height: 22px;
    }
  }
  .phone-number-input {
    max-width: 430px;
  }

  .outlined-body {
    display: flex;
    min-height: 96px;
    padding: 16px;
    justify-content: space-between;
    flex-direction: column;
    border-radius: 8px;
    border: 1px solid #d9e2eb;
    font-size: 16px;
    @media (max-width: $mobile) {
      p.has-text-weight-bold {
        font-size: 14px;
      }
      flex-direction: column;
      align-items: start;
      gap: 16px;
    }
    .label-group {
      @media (max-width: $mobile) {
        gap: 16px;
        flex-direction: column;
        align-items: start !important;
      }
    }
  }
  .outlined-content {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }
  .alert-delete-guests {
    padding: 16px 24px;
    display: flex;
    margin-top: 16px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    border-radius: 8px;
    background: rgba(255, 221, 153, 0.3);
    color: #a06f15;
    font-size: 14px;
    line-height: 100%;
  }
  .input-select {
    box-shadow: none;
    border: none;
    border-radius: 8px;
    border: 1px solid rgba(180, 197, 214, 0.5);
    background: white;
    padding: 32px 16px;
    width: auto;
    cursor: pointer;
    select {
      cursor: pointer;
    }
  }
  .alert-select {
    border-color: $error !important;
    .select:not(.is-multiple):not(.is-loading)::after {
      border-color: $error !important;
    }
  }
  .gap-32 {
    gap: 32px;
  }
  .outlined-field {
    border-radius: 8px;
    border: 1px solid rgba(180, 197, 214, 0.5);
    padding: 0 26px;
    height: 56px;
    gap: 8px;
    &:focus {
      border: 1px solid $neutrallight;
      box-shadow: 0px 0px 3px 0px $neutrallight !important;
    }
  }
  .register-guests {
    display: flex;
    flex-direction: column;
    gap: 48px;
    @media (max-width: $tablet) {
      gap: 32px;
    }
    &__title {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 16px;
      p {
        color: $gray-6;
        font-size: 24px;
        font-weight: 700;
      }
      span {
        color: $neutral;
        font-size: 16px;
        font-weight: 400;
        line-height: 20px;
      }
    }
  }
  .layout {
    background: white;
  }
}
</style>
